import { forwardRef, type ComponentPropsWithoutRef } from "react";

import { cn } from "core/shadcn/lib/utils";

type HeadingLevel = 1 | 2 | 3 | 4 | 5;

const TAG: Record<HeadingLevel, "h1" | "h2" | "h3" | "h4" | "h5"> = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4",
  5: "h5",
};

const SIZE: Record<HeadingLevel, string> = {
  1: "text-4xl",
  2: "text-3xl",
  3: "text-2xl",
  4: "text-xl",
  5: "text-base",
};

/**
 * A heading whose level picks both the element and the size, so the same
 * level looks the same on every page. It has no margin: space it with the
 * parent's gap or a margin class.
 */
export const Heading = forwardRef<
  HTMLHeadingElement,
  ComponentPropsWithoutRef<"h2"> & { level: HeadingLevel }
>(function Heading({ level, className, ...props }, ref) {
  const Tag = TAG[level];
  return (
    <Tag
      className={cn(SIZE[level], "font-semibold", className)}
      ref={ref}
      {...props}
    />
  );
});
